import { CustomerCategory } from '../models';
export var isOrisalesAvailable = function isOrisalesAvailable(userType) {
  return userType === CustomerCategory.Consultant;
};